import React from "react";
import Header from "../../../components/header/Header";
import { ReactComponent as Ok } from "../../../assets/icons/depositCrypto/Ok.svg";
import "./DepositApprove.css";
import Button from "../../../components/button/Button";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
const DepositApprove = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  return (
    <div className="DepositApprove">
      <Header hasMenu2={true} />

      <div className="DepositApproveWrapper">
        <div className="Approve">
          <Ok />
          <h2>{t("depositApprove.text")}</h2>
          <Button
            onClick={() => navigate("/transactions")}
            text={t("depositApprove.back")}
          />
        </div>
      </div>
    </div>
  );
};

export default DepositApprove;
